/**
 * A component that renders a small message denoting a start of a new session for user conversation.
 */
import React from "react";
import { connect } from "react-redux";

import styled from "styled-components";
import type { GlobalState } from "../lib/types";

/**
 * NewSessionMessage component.
 */
class NewSessionMessageComponent extends React.Component {
  render() {
    const { date, localHistoryLoaded } = this.props;
    const formattedDate = new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    if (!localHistoryLoaded) {
      return null;
    }

    return (
      <NewSessionMessage>
        <div className="text">{formattedDate}</div>
        <div className="divider">
          <div className="text">Conversation session completed</div>
          <div className="line" />
        </div>
      </NewSessionMessage>
    );
  }
}

const NewSessionMessage = styled.div`
  position: relative;
  color: #3a3a3c;
  text-align: center;
  width: 100%;

  > .text {
    font-size: 12px;
    line-height: 12px;
    padding: 3px 8px;
    position: relative;
    z-index: 1;
    display: inline-block;
    background-color: #fafafa;
    border-radius: 6px;
    border: 1px solid #d8d8d8;
    margin: 5px 0 10px;
  }

  .divider {
    position: relative;
    margin-bottom: 15px;
    text-align: center;

    .text {
      font-size: 11px;
      line-height: 16px;
      padding: 4px 16px;
      position: relative;
      z-index: 1;
      display: inline;
      background-color: #fff;
      color: #2c2c2c;
      border-radius: 12px;
      display: inline-block;
    }

    .line {
      position: absolute;
      width: 100%;
      border-top: 1px solid #efefef;
      top: 50%;
      left: 0;
    }
  }
`;

/**
 * Map state to props.
 */
function mapStateToProps(state: GlobalState, ownProps) {
  return {
    ...ownProps,
    localHistoryLoaded: state.localHistoryLoaded,
  };
}

export default connect(mapStateToProps)(NewSessionMessageComponent);
